//  icons
import {
  FiYoutube,
  FiInstagram,
  FiGithub,
  FiDribbble,
  FiLayout,
  FiSettings,
  FiPenTool,
  FiMail,
  FiMapPin,
} from 'react-icons/fi';


// projects images
import Project1 from './assets/img/projects/1mission.png';
import Project2 from './assets/img/projects/2influencer.png';
import Project3 from './assets/img/projects/3penguin.png';
import Project4 from './assets/img/projects/4penguin.png';
import Project5 from './assets/img/projects/5phone.png';
import Project6 from './assets/img/projects/6laptop.png';
import Project7 from './assets/img/projects/7emajohn.png';
import Project8 from './assets/img/projects/8good.png';
import Project9 from './assets/img/projects/9mealdb.png';
import Project10 from './assets/img/projects/10car.png';
import Project11 from './assets/img/projects/11converntion.png';
import Project12 from './assets/img/projects/12youtube.png';
import Project13 from './assets/img/projects/13redstore.png';
import Project14 from './assets/img/projects/14red.png';
import Project15 from './assets/img/projects/15edu1.png';
import Project16 from './assets/img/projects/16camera1.png';
import Project17 from './assets/img/projects/17doctor.png';
import Project18 from './assets/img/projects/18handy1.png';
import Project19 from './assets/img/projects/19manufacture.png';
import Project20 from './assets/img/projects/20JobOnboard.png';

// skills images
import SkillImg1 from './assets/img/skills/html5.png';
import SkillImg2 from './assets/img/skills/css3.png';
import SkillImg3 from './assets/img/skills/js.png';
import SkillImg4 from './assets/img/skills/reactjs.png';
import SkillImg5 from './assets/img/skills/firebase.png';
import SkillImg6 from './assets/img/skills/nodejs.png';
import SkillImg7 from './assets/img/skills/git.png';
import SkillImg8 from './assets/img/skills/figma.png';

// testimonial images
import TestiImage1 from './assets/img/testimonials/image1.png';
import TestiImage2 from './assets/img/testimonials/image2.jpg';
import TestiImage3 from './assets/img/testimonials/shijuka.jpg';

// navigation
export const navigation = [
  {
    name: 'home',
    href: 'home',
  },
  {
    name: 'about',
    href: 'about',
  },
  {
    name: 'Projects',
    href: 'portfolio',
  },
  {
    name: 'services',
    href: 'services',
  },
  {
    name: 'testimonials',
    href: 'testimonials',
  },
  {
    name: 'blog',
    href: 'blog',
  },
  {
    name: 'contact',
    href: 'contact',
  },
];

// social
export const social = [
  {
    icon: <FiYoutube />,
    href: '',
  },
  {
    icon: <FiInstagram />,
    href: '',
  },
  {
    icon: <FiGithub />,
    href: '',
  },
  {
    icon: <FiDribbble />,
    href: '',
  },
];

// projects
export const projectsData = [
  {
    id: '1',
    image: Project1,
    name: 'Mission 2022',
    des: '',
    imgLink: 'https://i.ibb.co/2FqYDYr/1mission.png',
    category: 'assignment',
    github: 'https://github.com/EmtiazHossainE2/mission-2022',
    liveLink: 'https://emtiazhossaine2.github.io/mission-2022/',
  },
  {
    id: '2',
    image: Project2,
    name: 'Influencer Products',
    des: '',
    imgLink: 'https://i.ibb.co/dLmMdYr/2influencer.png',
    category: 'assignment',
    github: 'https://github.com/EmtiazHossainE2/influencer-products',
    liveLink: 'https://emtiazhossaine2.github.io/influencer-products/',
  },
  {
    id: '3',
    image: Project3,
    name: 'Leader Board',
    des: '',
    imgLink: 'https://i.ibb.co/zXhNp0x/3board.png',
    category: 'course',
    github: 'https://github.com/EmtiazHossainE2/leader-board-using-b5',
    liveLink: 'https://emtiazhossaine2.github.io/leader-board-using-b5/',
  },
  {
    id: '4',
    image: Project4,
    name: 'Penguin Fashion',
    des: '',
    imgLink: 'https://i.ibb.co/twRSpm3/4penguin.png',
    category: 'course',
    github: 'https://github.com/EmtiazHossainE2/Penguin-Fashion',
    liveLink: 'https://emtiazhossaine2.github.io/Penguin-Fashion/',
  },
  {
    id: '5',
    image: Project5,
    name: 'Phone Hunter',
    des: '',
    imgLink: 'https://i.ibb.co/j3W1Gn5/5phone.png',
    category: 'assignment',
    github: 'https://github.com/EmtiazHossainE2/phone-hunter',
    liveLink: 'https://emtiaz-by-explore-phone.netlify.app/',
  },
{
    id: '6',
    image: Project6,
    name: 'Laptop Warehouse',
    des: '',
    imgLink: 'https://i.ibb.co/3FbHvWM/6laptop.png',
    category: 'practice',
    github: 'https://github.com/EmtiazHossainE2/laptop-warehouse',
    liveLink: 'https://laptop-warehouse.netlify.app/',
  },
{
    id: '7',
    image: Project7,
    name: 'Ema John',
    des: '',
    imgLink: 'https://i.ibb.co/SfytjsJ/7emajohn.png',
    category: 'course',
    github: 'https://github.com/EmtiazHossainE2/ema-john',
    liveLink: 'https://ema-john-responsive.web.app/',
  },
{
    id: '8',
    image: Project8,
    name: 'Good Wish Foundation',
    des: '',
    imgLink: 'https://i.ibb.co/4MN7pv0/8good.png',
    category: 'practice',
    github: 'https://github.com/EmtiazHossainE2/good-wish-fundation',
    liveLink: 'https://good-wish-foundation.web.app/',
  },
{
    id: '9',
    image: Project9,
    name: 'Mealdb',
    des: '',
    imgLink: 'https://i.ibb.co/y0mS2rj/9mealdb.png',
    category: 'practice',
    github: 'https://github.com/EmtiazHossainE2/our-mealdb',
    liveLink: 'https://our-mealdb-by-emtiaz.netlify.app/',
  },
{
    id: '10',
    image: Project10,
    name: 'Genius Car Service',
    des: '',
    imgLink: 'https://i.ibb.co/txm8nTS/10car.png',
    category: 'course',
    github: 'https://github.com/EmtiazHossainE2/genius-car-service-practice',
    liveLink: 'https://genius-car-service-310.web.app/',
  },
{
    id: '11',
    image: Project11,
    name: 'Convention Center',
    des: '',
    imgLink: 'https://i.ibb.co/489ntnh/11converntion.png',
    category: 'assignment',
    github: 'https://github.com/EmtiazHossainE2/convention-center',
    liveLink: 'https://victoria-convention-center.netlify.app/',
  },
{
    id: '12',
    image: Project12,
    name: 'Clone Youtube',
    des: '',
    imgLink: 'https://i.ibb.co/MGCQFDD/12youtube.png',
    category: 'practice',
    github: 'https://github.com/EmtiazHossainE2/youtube',
    liveLink: 'https://youtube-by-emtiazehossaine2.netlify.app/',
  },
{
    id: '13',
    image: Project13,
    name: 'Red Store',
    des: '',
    imgLink: 'https://i.ibb.co/rsQDBzC/13redstore.png',
    category: 'practice',
    github: 'https://github.com/EmtiazHossainE2/Red-Store',
    liveLink: 'https://emtiazhossaine2.github.io/Red-Store/',
  },
  {
    id: '14',
    image: Project14,
    name: 'Red Onion Roaster',
    des: '',
    imgLink: 'https://i.ibb.co/L1WmNDh/redonion.png',
    category: 'web development',
    github: 'https://github.com/EmtiazHossainE2/red-onion-roaster',
    liveLink: 'https://red-onion-roaster.web.app/',
  },
  {
    id: '15',
    image: Project15,
    name: 'Education Hub',
    des: '',
    imgLink: 'https://i.ibb.co/5xCrbPJ/edu.png',
    category: 'web development',
    github: 'https://github.com/EmtiazHossainE2/education-hub',
    liveLink: 'https://education-hub-101.web.app/',
  },
  {
    id: '16',
    image: Project16,
    name: 'Digital Camera Warehouse',
    des: '',
    imgLink: 'https://i.ibb.co/VWV24Nb/camera.jpg',
    category: 'web development',
    github: 'https://github.com/EmtiazHossainE2/digital-camera-warehouse',
    liveLink: 'https://digital-camera-warehouse.web.app/',
  },
  {
    id: '17',
    image: Project17,
    name: 'Doctors Portal',
    des: '',
    imgLink: 'https://i.ibb.co/r6xssCK/doctor.png',
    category: 'web development',
    github: 'https://github.com/EmtiazHossainE2/doctors-portal',
    liveLink: 'https://doctors-portal-f5c17.web.app/',
  },
  {
    id: '18',
    image: Project18,
    name: 'Handy Man',
    des: '',
    imgLink: 'https://i.ibb.co/fXJMxgK/handyman.jpg',
    category: 'web development',
    github: 'https://github.com/EmtiazHossainE2/handy-man-client',
    liveLink: 'https://handyman-e2fe9.web.app/',
  },
  {
    id: '19',
    image: Project19,
    name: 'Plumbtion Manufacture',
    des: '',
    imgLink: 'https://i.ibb.co/0X5T9nJ/plumbtion3.jpg',
    category: 'web development',
    github: 'https://github.com/EmtiazHossainE2/plumbtion-manufacturer',
    liveLink: 'https://plumbtion-manufacturer.web.app/',
  },
  {
    id: '20',
    image: Project20,
    name: 'Job OnBoard',
    des: '',
    imgLink: 'https://i.ibb.co/PC8H3cc/32051633-6efa8cac0f8584f2a6f498cd349346db.png',
    category: 'web development',
    github: 'https://github.com/EmtiazHossainE2/Job-OnBoard-Client',
    liveLink: 'https://job-on-board-client.vercel.app/',
  }
];

// projects
export const projectsNav = [


  {
    name: 'web development',
  },
  {
    name: 'course',
  },
  {
    name: 'assignment',
  },
  {
    name: 'practice',
  },
  {
    name: 'all',
  },
];

// skill
export const skills = [
  {
    image: SkillImg1,
  },
  {
    image: SkillImg2,
  },
  {
    image: SkillImg3,
  },
  {
    image: SkillImg4,
  },
  {
    image: SkillImg5,
  },
  {
    image: SkillImg6,
  },
  {
    image: SkillImg7,
  },
  {
    image: SkillImg8,
  },
];

// services
export const services = [
  {
    icon: <FiLayout />,
    name: 'Figma To React',
    description:
      'I can do any figma file to convert it into  a responsive, professional, and pixel-perfect React.js website.  I am ready to use any npm packages or other CSS/UI frameworks by the project requirements.',
  },
  {
    icon: <FiSettings />,
    name: 'Frontend Development',
    description:
      'I am able to build a responsive website so that your website will look perfect on all the small and wide screens.I have almost 6 month of experience and complete almost 20+ projects.. I have good skills on HTML5, CSS3, BOOTSTRAP, Tailwind CSS, JAVASCRIPT, REACT JS .',
  },
  {
    icon: <FiPenTool />,
    name: 'Backend Development',
    description:
      'I also have good hands-on experience about Mongodb , Express , Node Heroku . So i also build a MERN project .I am new to this portal but I will give you quality work. I am complete 5+ full-stack project . ',
  },
];

// testimonials
export const testimonials = [
  {
    authorImg: TestiImage1,
    authorText:
      'Very passionate about programing and really super talented, hard working and punctual boy. I know him through programing and he proved himself to remember him until I escape this programing field. Best wishes to you Mr rising start Programmer 💖',
    authorName: 'Shaikh Najmul Islam',
    authorPosition: 'Biotechnology and Genetic Engineer , BSMRSTU',
  },
  {
    authorImg: TestiImage2,
    authorText:
      'A Good Soul,  very thirsty to invent new something.  Programing is passion,  simplicity is  fashion. Kinda Boy who deserve a lot of success & oneday he will achieve it.',
    authorName: 'S J Rion Talukder',
    authorPosition: 'Rangpur Medical College , Rangpur .',
  },
  {
    authorImg: TestiImage3,
    authorText:
      'He is such a hard working man who does not know how to give up. I know he will shine in programming field by any means. Best of luck boy.' ,
    authorName: 'Muhaimina Tanshit',
    authorPosition: 'Political Science , Dhaka University ',
  },
];

// contact
export const contact = [
  {
    icon: <FiMail />,
    title: 'Have a question?',
    subtitle: 'I am here to help you.',
    description: 'Email me at emtiazhossainrzs@gmail.com',
  },
  {
    icon: <FiMapPin />,
    title: 'Current Location',
    subtitle: 'Emtiaz Park , Bus Terminal, Rangpur Sadar , Rangpur , Bangladesh',
    description: 'Serving clients worldwide',
  },
];
